module.exports = __webpack_public_path__ + "img/kairan.d92a9c08.png";